import type { ProjectPostUpdateCommand, ProjectPostUpdateResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class UpdateProjectPostUseCase {
  constructor(private projectRepository: ProjectRepository) {}

  async execute(command: ProjectPostUpdateCommand): Promise<ProjectPostUpdateResponse> {
    return this.projectRepository.updateProjectPost(command);
  }
}
